import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";

// all api calling using rtk query
import commonApis from "./common/commonApis";
import mastersApis from "./masters/mastersApis";
import usersApis from "./users/usersApis";
import trackingApis from "./tracking/trackingApis";
import ordersApis from "./orders/ordersApis";
import warrantyApis from "./warranty/warrantyApis";
import insuranceApis from "./insurance/insuranceApis";
import customerMasterApis from "./customerMaster/customerMasterApis";
import reportsApis from "./reports/reportsApis";
import alertsApis from "./alerts/alertsApis";

// redux state slices
import commonSlice from "./common/commonSlice";
import mastersSlice from "./masters/mastersSlice";
import trackingSlice from "./tracking/trackingSlice";
import ordersSlice from "./orders/ordersSlice";
import warrantySlice from "./warranty/warrantySlice";
import insuranceSlice from "./insurance/insuranceSlice";
import customerMasterSlice from "./customerMaster/customerMasterSlice";
import reportsSlice from "./reports/reportsSlice";
import alertsSlice from "./alerts/alertsSlice";

// axios interceptor
import axiosInterceptor from "../helpers/axios";

const reducers = {
    [commonSlice.name]: commonSlice.reducer,
    [mastersSlice.name]: mastersSlice.reducer,
    [trackingSlice.name]: trackingSlice.reducer,
    [ordersSlice.name]: ordersSlice.reducer,
    [warrantySlice.name]: warrantySlice.reducer,
    [insuranceSlice.name]: insuranceSlice.reducer,
    [customerMasterSlice.name]: customerMasterSlice.reducer,
    [reportsSlice.name]: reportsSlice.reducer,
    [alertsSlice.name]: alertsSlice.reducer,
    [commonApis.reducerPath]: commonApis.reducer,
    [mastersApis.reducerPath]: mastersApis.reducer,
    [usersApis.reducerPath]: usersApis.reducer,
    [trackingApis.reducerPath]: trackingApis.reducer,
    [ordersApis.reducerPath]: ordersApis.reducer,
    [warrantyApis.reducerPath]: warrantyApis.reducer,
    [insuranceApis.reducerPath]: insuranceApis.reducer,
    [customerMasterApis.reducerPath]: customerMasterApis.reducer,
    [reportsApis.reducerPath]: reportsApis.reducer,
    [alertsApis.reducerPath]: alertsApis.reducer,
};

const initialState = {};

const rootReducer = combineReducers(reducers);

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: false,
        }).concat([
            commonApis.middleware,
            mastersApis.middleware,
            usersApis.middleware,
            trackingApis.middleware,
            ordersApis.middleware,
            warrantyApis.middleware,
            insuranceApis.middleware,
            customerMasterApis.middleware,
            reportsApis.middleware,
            alertsApis.middleware,
        ]);
    },
    devTools: true,
    preloadedState: initialState,
    // enhancers: (defaultEnhancers) => [...defaultEnhancers]
});

export const useAppSelector = useSelector;
export const useAppDispatch = useDispatch;

axiosInterceptor(store.dispatch);

export default store;
